import { render, staticRenderFns } from "./LPJ.vue?vue&type=template&id=3ae1aeca&"
import script from "./LPJ.vue?vue&type=script&lang=js&"
export * from "./LPJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports